﻿import * as React from "react";

export interface IInformationTableTitle {
    word: string;
    color: string;
}

export interface IInfromationTableTitleProps {
    legendElements: IInformationTableTitle[];
}

export const InformationTableTitle: React.FunctionComponent<
    IInfromationTableTitleProps
> = (props: IInfromationTableTitleProps): React.ReactElement => (
    <div className={`informationTableTitle`}>
        Legend:
        {props.legendElements.map((element: IInformationTableTitle) => (
            // TODO: remove the disable and add a key prop
            // eslint-disable-next-line react/jsx-key
            <span>
                <div
                    className={`box`}
                    style={{ backgroundColor: element.color }}
                />
                {element.word}
            </span>
        ))}
    </div>
);
